export enum API_FILE_TYPES {
  JSON = 'JSON',
  YAML = 'YAML',
  GRAPHQL = 'GraphQL',
  GRPC = 'gRPC'
}

export const API_DOWNLOAD_FORMATS = [API_FILE_TYPES.JSON, API_FILE_TYPES.YAML]